import * as React from "react";
import { QAPropsBase, State, StatePackage, dateValidator, stringValidatorN } from "../State";
import QuestionAnswer from "./QuestionAnswer";
import { useContext, useState, ReactNode } from "react";
import { store, Action } from "../store";
import { DropdownProps, InputOnChangeData } from "semantic-ui-react";
import PCovTable from "../components/PCovTable";

// tslint:disable-next-line: interface-name
interface PCovTableAnswerState {
    date: string;
    name: string;
    id: string;
    dateIsValid: boolean;
    nameIsValid: boolean;
    tableIsVisible: boolean;
}

interface PCovTableAnswerProps {
    index: number;
    byCarrier?: boolean;
    propsBase: QAPropsBase;
}

// tslint:disable-next-line: max-line-length
function handleDateChange(d: InputOnChangeData, dispatch: React.Dispatch<Action>, action: Action, index: number, s2: StatePackage<PCovTableAnswerState>): void {
    const isValid = dateValidator(d.value);
    s2.setState({ ...s2.state, date: d.value, dateIsValid: isValid, tableIsVisible: isValid && s2.state.nameIsValid });
    dispatch({
        ...action,
        value: {
            entityID: "",
            entityName: s2.state.name,
            policyEffectiveDate: d.value,
        },
        index: index
    });
}

// tslint:disable-next-line: max-line-length
function handleNameChange(d: InputOnChangeData, dispatch: React.Dispatch<Action>, action: Action, index: number, s2: StatePackage<PCovTableAnswerState>): void {
    const stringValidator = stringValidatorN(0 , 1000);
    const isValid = stringValidator(d.value);
    s2.setState({ ...s2.state, name: d.value, nameIsValid: isValid, dateIsValid: s2.state.date.length > 0, tableIsVisible: s2.state.dateIsValid && isValid });
    dispatch({
        ...action,
        value: {
            entityID: "",
            entityName: d.value,
            policyEffectiveDate: s2.state.date,
        },
        index: index
    });
}

// tslint:disable-next-line: max-line-length
function handleIDChange(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, name: string, id: string, index: number, dispatch: React.Dispatch<Action>, action: Action, s2: StatePackage<PCovTableAnswerState>): void {
    e.preventDefault();
    s2.setState({ ...s2.state, name, id });
    dispatch({
        ...action,
        value: {
            entityID: id,
            entityName: name,
            policyEffectiveDate: s2.state.date,
        },
        index: index
    });
}

const PCovTableAnswer: React.FunctionComponent<PCovTableAnswerProps> = (props: PCovTableAnswerProps) => {
    const [state, setState] = useState<PCovTableAnswerState>({ date: "", name: "", id: "", dateIsValid: false, nameIsValid: false, tableIsVisible: false });
    // tslint:disable-next-line: max-line-length
    const debouncedResult = state.dateIsValid && state.nameIsValid;
    const action = { type: "handle answer update" };

    const globalState = useContext(store);
    const { dispatch } = globalState;

  return (
    <div className="quiz">
          {
              <div>
                  <QuestionAnswer index={-1}
                        propsBase={{
                            answerContent: "",
                            answerType: "date", answerValidator: dateValidator,
                            isRequired: true,
                            answerValue: state.date,
                            isAnswered: state.date.length > 0 || (state.name.length > 0 && !state.dateIsValid),
                            isAnswerValid: state.dateIsValid,
                            showError: true,
                            questionContent: "POLICY EFFECTIVE DATE",
                            errorProps: { content: "Please enter a valid date" },
                            propName:"N/A"
                        }}
                        // tslint:disable-next-line: max-line-length
                      onChange={(e, i, d) => handleDateChange(d as InputOnChangeData, dispatch, action, props.index, { setState, state })}
                   />
                  <QuestionAnswer index={-2}
                      propsBase={{
                          answerContent: "",
                          answerType: "text", answerValidator: stringValidatorN(1000),
                          isRequired: true,
                          answerValue: state.name, isAnswerValid: state.nameIsValid,
                          isAnswered: state.name.length > 0, showError: false,
                          questionContent: "NAME OF ENTITY",
                          errorProps: { content: "Please enter a valid name of entity" },
                          propName: "N/A"
                      }}
                          // tslint:disable-next-line: max-line-length
                      onChange={(e, i, d) => handleNameChange(d as InputOnChangeData, dispatch, action, props.index, { setState, state })}
                   />
              </div>
        }
          {
              state.tableIsVisible &&
              <PCovTable propsBase={props.propsBase} byCarrier={props.byCarrier} onChange={(e, v, i) => handleIDChange(e, v, i, props.index, dispatch, action, { setState, state })} />
        }
    </div>
  );
};

export default PCovTableAnswer;
